import { render } from "./UsuariosUbicaciones.vue?vue&type=template&id=eddf9570&scoped=true"
import script from "./UsuariosUbicaciones.vue?vue&type=script&lang=js"
export * from "./UsuariosUbicaciones.vue?vue&type=script&lang=js"

import "./UsuariosUbicaciones.vue?vue&type=style&index=0&id=eddf9570&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddf9570"]])

export default __exports__